import * as React from "react";
const SvgFiRrUserNinja = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M12 14c-4.411 0-8 3.589-8 8v1a1 1 0 1 0 2 0v-1c0-1.588.625-3.03 1.636-4.105 1.011 1.679 2.403 3.839 3.869 5.72.191.245.485.384.796.384.839 0 1.303-.961.791-1.625l-.03-.041c1.419-1.497 2.519-3.114 3.298-4.445a5.97 5.97 0 0 1 1.641 4.111v1a1 1 0 1 0 2 0v-1c0-4.411-3.589-8-8-8zm-2.761 2.678a5.96 5.96 0 0 1 5.514-.003c-.68 1.187-1.647 2.654-2.896 4.023a65 65 0 0 1-2.618-4.019zM15 5.5A1.5 1.5 0 0 1 13.5 7h-3a1.5 1.5 0 0 1 0-3h3A1.5 1.5 0 0 1 15 5.5m5.608.517c-.42-.296-.943-.443-1.449-.517.506-.074 1.029-.222 1.449-.517.725-.51 1.141-1.444 1.359-2.117a.66.66 0 0 0-.615-.864c-.72-.015-1.761.07-2.491.583-.545.384-.909 1.005-1.152 1.577A6.01 6.01 0 0 0 12 0C8.691 0 6 2.691 6 6s2.691 6 6 6a6.01 6.01 0 0 0 5.879-4.798c.236.458.552.911.982 1.214.729.514 1.771.598 2.491.583a.66.66 0 0 0 .615-.864c-.219-.674-.635-1.608-1.359-2.118M12 10c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4"
    />
  </svg>
);
export default SvgFiRrUserNinja;
